
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 18 18"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","fill-rule":"evenodd","d":"M9.744 2.87l-.969.969-1.06-1.06L10.494 0l2.779 2.779-1.06 1.06-.97-.97v5.515a2.25 2.25 0 11-1.499 0V2.87zm.75 6.885a.75.75 0 100 1.499.75.75 0 000-1.5zm5.996-2.249h-3.747V6.007h5.246v8.995H3V6.007h5.246v1.5H4.497v5.996H16.49V7.506zM1.5 16.501h12.742V18H0V9.755h1.5V16.5z","clip-rule":"evenodd"}})])
          )
        }
      }
    